module.exports = __webpack_public_path__ + "img/clock.e398bdd2.png";